import Methods from "../methods";

const getClientInformationById = (context, payload) => {
  const url = `api/clients/${payload.clientId}`;
  return Methods.doGet(context, url, null)
};

const saveAndUpdateColumns = (context, payload) => {
  const url = `api/clients/${payload.clientId}/columns`;
  return Methods.doPost(context, url, payload.data, null)
};

/*const getFileTypeByClient = (context, payload) => {
  const url = `api/files/type/${payload.client}`;
  return Methods.doGet(context, url, null)
};*/

const getAreasByClient = (context, clientId) => {
  const url = `api/clients/${clientId}/areas`;
  return Methods.doGet(context, url);
};

export default {
  saveAndUpdateColumns,
  getClientInformationById,
  getAreasByClient,
}



// WEBPACK FOOTER //
// ./src/api/modules/ClientApi.js